import { styled } from '@linaria/react';
export const PageWrapper = /*#__PURE__*/styled('div')({
  name: "PageWrapper",
  class: "p1mrcrhe",
  propsAsIs: false
});
export const Form = /*#__PURE__*/styled('form')({
  name: "Form",
  class: "f1mdw720",
  propsAsIs: false
});
export const CopySectionWrapper = /*#__PURE__*/styled('div')({
  name: "CopySectionWrapper",
  class: "c12h35vm",
  propsAsIs: false
});

require("./styled.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styled.tsx");